import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../context/LoginContext';
import { useNavigate } from 'react-router-dom';

const PhonePePayment = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, userId, userName, userData } = useContext(LoginContext);



  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, []);


  const handlePayment = async () => {
    setLoading(true);
    try {
      const orderId = `order_${Date.now()}`;
      const amount = (99*100); // Amount in paisa (100 Rs)

      // Call Laravel API to initiate payment
      const response = await axios.post(process.env.REACT_APP_API_PAYMENT_URL + 'phonepe/initiate', {
        order_id: orderId,
        amount: amount,
        user_id: userId,
        name: userName,
        email: userData.email,
        gender: userData.gender,
        plan: "Premium",
        callbackUrl: process.env.REACT_APP_API_PAYMENT_CALLBACK_URL
      });

      if (response.data && response.data.redirectUrl) {
        // Redirect user to PhonePe payment page
        window.location.href = response.data.redirectUrl;
      } else {
        alert('Failed to get payment URL');
      }
    } catch (error) {
      console.error('Payment initiation error:', error);
      alert('Payment initiation failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      <div className='container'>
        <div className="row justify-content-center">

          <div className="col-md-4 my-3">
            <div className="card mx-auto pricing-card shadow-sm p-3">
              <div className="card-body d-flex " style={{ flexDirection: "column" }}>
                <span className="badge bg-warning text-dark mb-2 mx-auto">Most Popular Plan</span>
                <h5 className="card-title text-center">Premium</h5>
                <p className="card-subtitle mb-3 text-muted text-center" style={{ color: "#A16304" }}>India's Trusted Matrimony Services</p>
                <table className='table table-bordered'>
                  <tbody>
                  <tr>
                    <td> <p className='fw-bold mb-0 fs-4'><span className="fw-bold fs-4">₹ 99 </span>/- Annually</p> </td>
                  </tr>
                  </tbody>
                </table>

                <button className="btn btn-danger w-100 mb-3" onClick={handlePayment} disabled={loading}>
                  {loading ? 'Upgrading...' : 'Upgrade Plan'}
                </button>


              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
  );
};

export default PhonePePayment;
